import { withStripe } from '../Stripe';
import { StripeCheckout as StripeCheckoutComponent } from './stripeCheckout';

export const StripeCheckout = withStripe(StripeCheckoutComponent);
